import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'app/shared/api/microservices';

const n8nBaseUrl = process.env.N8N_SCORINGJOE_URL ?? '';

export const n8nWebhookApi = createApi({
  reducerPath: 'n8nWebhookApi',
  baseQuery: axiosBaseQuery({ baseUrl: n8nBaseUrl }),
  endpoints: build => ({
    produceNewsletter: build.query<{ executionId: string }, { id: string; type: string }>({
      query: ({ id, type }) => ({
        url: `/webhook/newsletter/produce-${type}`,
        method: 'GET',
        params: { id: encodeURIComponent(id) },
      }),
    }),
    sendNewsletter: build.query<void, { id: string }>({
      query: ({ id }) => ({
        url: '/webhook/newsletter/send',
        method: 'GET',
        params: { id },
      }),
    }),
  }),
});

export const { useLazyProduceNewsletterQuery, useLazySendNewsletterQuery } = n8nWebhookApi;
